import React, { useState, useEffect } from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui/icons
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";

import styles from "assets/jss/material-kit-react/views/learningPage.js";
import Axios from "axios";
import Config from "../../../config.js"
import History from "components/History";
const useStyles = makeStyles(styles);

export default function LearningLogPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  const imageClasses = classNames(
    classes.imgRaised,
    classes.imgRoundedCircle,
    classes.imgFluid
  );
    return (
      <div>
        <Header
          color="transparent"
          brand="Material Kit React"
          rightLinks={<HeaderLinks />}
          fixed
          changeColorOnScroll={{
            height: 30,
            color: "white"
          }}
          {...rest}
        />
        <Parallax verySmall filter image={require("assets/img/bg17.jpg")} />
        <div className={classNames(classes.main, classes.mainRaised)}>
          <div>
    
            <div className={classes.container}>
            <History  order="DESC" title="گزارش ثبت نام"></History>
    
              <div>
              </div>
              <div className={classes.description}>
                <p>
                  {" "}
                </p>
              </div>
              <GridContainer justify="center">
              </GridContainer>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    )
                    }
